<template>
  <v-dialog v-model="value" max-width="500">
    <v-card>
      <v-card-title class="title blue white--text mb-5">
        <v-icon left color="blue lighten-4">mdi-sitemap</v-icon>
        {{ $t("PANEL.MODULE.INFORMATION_DIALOG.TITLE") }}
      </v-card-title>

      <v-card-text>
        {{ $t("PANEL.MODULE.INFORMATION_DIALOG.MODULE_NAME") }}: <b>{{ name }}</b>
        <br />
        {{ $t("PANEL.MODULE.INFORMATION_DIALOG.MODULE_DESC") }}: <b>{{ desc }}</b>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog"> {{ $t("PANEL.MODULE.INFORMATION_DIALOG.CLOSE_DIALOG") }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModuleInfoDialog",
  props: {
    value: {
      type: Boolean
    },
    name: {
      type: String
    },
    desc: {
      type: String
    }
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    }
  }
};
</script>

<style></style>
